import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginMembre } from '../services/api';
import Footer from '../components/Footer';
import './LoginMembre.css';

const LoginMembre = () => {
  const [numeroMatricule, setNumeroMatricule] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Normaliser les valeurs
    const numeroMatriculeNormalise = numeroMatricule.toUpperCase().trim();
    const passwordNormalise = password.toUpperCase().trim();

    if (!numeroMatriculeNormalise || !passwordNormalise) {
      setError('Veuillez remplir tous les champs');
      setLoading(false);
      return;
    }

    try {
      const response = await loginMembre(numeroMatriculeNormalise, passwordNormalise);
      
      if (response.data && response.data.membre) {
        const membreData = response.data.membre;
        
        // Vérifier que le membre a au moins un numéro matricule
        if (!membreData.numero_matricule) {
          setError('Données du membre invalides');
          setLoading(false);
          return;
        }
        
        // Stocker les données du membre
        localStorage.setItem('membre_user', JSON.stringify(membreData));
        
        // Vérifier que le stockage a réussi
        const stored = localStorage.getItem('membre_user');
        if (!stored) {
          setError('Erreur lors du stockage des données');
          setLoading(false);
          return;
        }
        
        // Rediriger vers le dashboard
        navigate('/membre', { replace: true });
      } else {
        setError('Réponse invalide du serveur');
        setLoading(false);
      }
    } catch (err) {
      let errorMessage = 'Erreur de connexion';
      
      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.code === 'ERR_NETWORK' || err.message === 'Network Error') {
        errorMessage = 'Impossible de se connecter au serveur. Vérifiez votre connexion internet.';
      } else if (err.response?.status === 401) {
        errorMessage = 'Numéro matricule ou mot de passe incorrect.';
      }
      
      setError(errorMessage);
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-container">
        <div className="login-box">
          <div className="logo-container">
            <img src="/logo.png" alt="MUTU NDE ESPOIR ASBL" className="logo" />
          </div>
          <h2>MUTU NDE ESPOIR ASBL</h2>
          <h3>Espace Membre</h3>
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-error">{error}</div>}
            
            <div className="form-group">
              <label>Numéro matricule</label>
              <input
                type="text"
                value={numeroMatricule}
                onChange={(e) => setNumeroMatricule(e.target.value.toUpperCase())}
                required
                placeholder="Ex: MNE-001"
                autoFocus
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label>Mot de passe</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value.toUpperCase())}
                required
                placeholder="3 chiffres + 3 lettres"
                maxLength="6"
                autoComplete="current-password"
                disabled={loading}
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary" 
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LoginMembre;
